// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import {apiSlice} from './apiSlice';

export const sessionFileApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createSessionFile: builder.mutation({
      query: body => ({
        url: 'session_file/',
        method: 'POST',
        body
      }),
      // invalidatesTags: [],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateSessionFileMutation
} = sessionFileApi;
